export const LOGIN_TYPE_MANUAL = 'Manual';
export const LOGIN_TYPE_QR = 'QR';
export const LOGIN_TYPE_OTT = 'OTT';
export const LOGIN_TYPE_UNKNOWN = 'Unknown';


// WEBPACK FOOTER //
// ./src/constants/loginTypes.js